import { db } from "./firebase";
import { updateDoc, doc } from "firebase/firestore";

export const putProperty = async (propertyId, updatedData) => {
  // Referencia al documento en Firestore
  const propertyRef = doc(db, "propiedades", propertyId);

  try {
    // Actualizar el documento con los nuevos datos
    await updateDoc(propertyRef, updatedData);
    //console.log("Propiedad actualizada con éxito");
  } catch (error) {
    console.error("Error al actualizar la propiedad:", error);
  }
};
